<div class="modal-content modal-milvus">
    <div class="modal-header-milvus align-items-center">
        <div class="col-8 header-col">
            <span class="modal-title" *ngIf="create" [translate]="'NOVA_CONDICAO_E'"></span>
            <span class="modal-title" *ngIf="!create" [translate]="'EDITAR_CONDICAO_E'"></span>
        </div>
        <div class="col-4 header-col">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <i class="mdi mdi-close"></i>
            </button>
        </div>
    </div>

    <div class="modal-body" [formGroup]="condicaoForm">
        <div class="row align-items-end">
            <div class="col-md-6 form-group">
                <label [translate]="'ENTIDADE'"></label>
                <select-padrao [selectModalPequeno]="true" [ngClass]="{'required': condicaoForm.controls.entidade_id.invalid && condicaoForm.controls.entidade_id.touched}" [entidade]="'customContent'" [params]="entidadesFiltro" [model]="condicaoForm.value.entidade_id" [required]="true" (selectChange)="condicaoForm.patchValue({entidade_id: $event})"></select-padrao>
            </div>
            <div class="col-md-6 form-group">
                <label>Selecione o campo</label>
                <select-padrao [selectModalPequeno]="true" [ngClass]="{'required': condicaoForm.controls.campo_id.invalid && condicaoForm.controls.campo_id.touched}" [entidade]="'selectCamposFiltros'" [customPlaceholder]="'CAMPO'" [model]="campoSelecionado" [required]="true" [returnObj]="true" [params]="paramsCampos" (selectChange)="patchCampoCondicao($event)"></select-padrao>
            </div>
        </div>
        <div class="row align-items-end">
            <div class="col-md-6 form-group">
                <label>Selecione o operador</label>
                <select-padrao [selectModalPequeno]="true" [ngClass]="{'required': condicaoForm.controls.operador_id.invalid && condicaoForm.controls.operador_id.touched}" [entidade]="'customContent'" [params]="operadoresCondicao" [model]="condicaoForm.value.operador_id" [required]="true" [returnObj]="false" (selectChange)="condicaoForm.patchValue({operador_id: $event})"></select-padrao>
            </div>
            <div class="col-md-6 form-group" *ngIf="condicaoForm.value.tipo_campo_id === 2 || !condicaoForm.value.tipo_campo_id">
                <label>Selecione o valor</label>
                <input type="text" class="form-control" formControlName="valor" [ngClass]="{'required': condicaoForm.controls.valor.invalid}">
            </div>
            <div class="col-md-6 form-group" *ngIf="condicaoForm.value.tipo_campo_id === 3">
                <label>Selecione o valor</label>
                <input type="date" class="form-control" formControlName="valor" [ngClass]="{'required': condicaoForm.controls.valor.invalid}">
            </div>
            <div class="col-md-6 form-group" *ngIf="condicaoForm.value.tipo_campo_id === 4 || condicaoForm.value.tipo_campo_id === 6">
                <label>Selecione o valor</label>
                <input type="number" class="form-control number-input" formControlName="valor" [ngClass]="{'required': condicaoForm.controls.valor.invalid}">
            </div>
            <div class="col-md-6 form-group" *ngIf="condicaoForm.value.tipo_campo_id === 5">
                <label>Selecione o valor</label>
                <select class="form-control" formControlName="valor" [ngClass]="{'required': condicaoForm.controls.valor.invalid}">
                    <option [ngValue]="true" [translate]="'SIM'"></option>
                    <option [ngValue]="false" [translate]="'NAO'"></option>
                </select>
            </div>
            <div class="col-md-6 form-group" *ngIf="(condicaoForm.value.tipo_campo_id === 7 || condicaoForm.value.tipo_campo_id === 9) && condicaoForm.value.campo_chave !== chaveCampoUnidade">
                <label>Selecione o valor</label>
                <select-padrao [selectModalPequeno]="true" [ngClass]="{'required': condicaoForm.controls.valor.invalid && condicaoForm.controls.valor.touched}" [multiple]="condicaoForm.value.tipo_campo_id === 9" [entidade]="'selectValoresCondicaoFiltro'" [customPlaceholder]="'VALOR'" [model]="valorSelecionado" [required]="true" [params]="condicaoForm.value.campo_chave" [returnObj]="false" (selectChange)="condicaoForm.patchValue({valor: $event})"></select-padrao>
            </div>
        </div>
        <div class="row align-items-end" *ngIf="condicaoForm.value.campo_chave === chaveCampoUnidade">
            <div class="col-md-6 form-group">
                <label [translate]="'CLIENTE'"></label>
                <select-padrao [selectModalPequeno]="true" [entidade]="'selectValoresCondicaoFiltro'" [customPlaceholder]="'SELECIONE_CLIENTE'" [model]="clienteUnidade" [params]="chaveCampoCliente" [returnObj]="false" (selectChange)="patchClientesUnidade($event)"></select-padrao>
            </div>
            <div class="col-md-6 form-group">
                <label>Selecione o valor</label>
                <select-padrao [selectModalPequeno]="true" [ngClass]="{'required': condicaoForm.controls.valor.invalid && condicaoForm.controls.valor.touched}" [multiple]="true" [entidade]="'selectValoresCondicaoFiltro'" [customPlaceholder]="'VALOR'" [model]="valorSelecionado" [required]="true" [disabled]="!unidadeParams" [params]="unidadeParams" [returnObj]="false" (selectChange)="condicaoForm.patchValue({valor: $event})"></select-padrao>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-success badge-pill" [disabled]="condicaoForm.invalid" (click)="salvar()">
            <i class="mdi mdi-content-save-outline"></i>
            <span [translate]="'SALVAR'"></span>
        </button>
    </div>
</div>
